import script from "./clinic-store.vue?vue&type=script&setup=true&lang=js"
export * from "./clinic-store.vue?vue&type=script&setup=true&lang=js"

import "./clinic-store.vue?vue&type=style&index=0&id=67307a9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67307a9c"]])

export default __exports__